import { render, staticRenderFns } from "./GfPlatformMenu.vue?vue&type=template&id=199e2fc4&lang=html"
import script from "./GfPlatformMenu.vue?vue&type=script&lang=js"
export * from "./GfPlatformMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports